
import webApi from './webApi'


const requestService = {
        
    fetchIncrement : async(timestamp)=>{
        return await webApi.httpGet('requests', {timestamp})
    },


    read : async(id)=>{
        return await webApi.httpPut('requests/'+id)
    },


    deny : async(action)=>{
        return await webApi.httpPost('requests', action)
    },

    allow : async(action)=>{
        return await webApi.httpPost('requests', action)
         
    },

    delete : async(id)=>{
        return await webApi.httpDelete('requests/'+id)
         
    },
}




export default requestService